<template>
    <div class="a_cus_wrap salebench_com">
        <!-- button -->
        <div class="btn">
            <el-button class="benchBtn benchBtnChecked" size="mini" v-if="module.indexOf(',customer-visit-edit,')!=-1" @click="addReturn">新增回访</el-button>
            <el-button class="benchBtn" size="mini" v-if="module.indexOf(',customer-index-rhei,')!=-1" @click="addBlackList">添加黑名单</el-button>
            <el-button class="benchBtn" size="mini" v-if="module.indexOf(',customer-add-common,')!=-1" @click="addCommonList">添加公共池</el-button>
        </div>
        <!-- table -->
        <!-- <div class="tableBox">
            <tabletem :isSetCol="true" scene="customer.index.list"  :isLoading="tableLoading" :tablecol="tableCol" :tabledata="customerData"></tabletem>
        </div> -->
        <el-table class="table" ref="singleTable" @selection-change="selectionChange" :data="customerData" v-loading = "isLoading" element-loading-background = "rgba(0, 0, 0, 0.3)" element-loading-text = "数据正在加载中" element-loading-spinner = "el-icon-loading" @row-click="handleRowClick" @sort-change='sortThisColumn' border stripe highlight-current-row  size="mini" style="width: 100%;overflow: hidden;" height="100%">
          <el-table-column class-name="tableIndex" v-if="customerColumn.indexOf(',name,')!=-1" type="selection" align="center"  width="45"></el-table-column>
          <!-- <el-table-column label="" width="45" align="center" v-if="customerColumn.indexOf(',name,')!=-1">
            <template v-slot="scope">
              <el-checkbox v-model="scope.row.checked"></el-checkbox>
              <div class="hideBox"></div>
            </template>
          </el-table-column> -->
          <el-table-column prop="customer" label="客户名称" width="180" show-overflow-tooltip v-if="customerColumn.indexOf(',name,')!=-1">
              <template v-slot="scope">
                  <span class="link" @click.stop="lintToInfo(scope.row.id, scope.row.name)">{{scope.row.name}}</span>
              </template>
          </el-table-column>
          <el-table-column prop="linkman" label="联系人" width="100" v-if="customerColumn.indexOf(',linkman,')!=-1" show-overflow-tooltip></el-table-column>
          <el-table-column prop="phone" label="联系电话" width="110" v-if="customerColumn.indexOf(',phone,')!=-1"></el-table-column>
          <el-table-column prop="salesman_name" label="归属人" width="100" v-if="customerColumn.indexOf(',salesman_name,')!=-1"></el-table-column>
          <el-table-column prop="customer_attribute_name" label="客户属性" width="100" v-if="customerColumn.indexOf(',customer_attribute_name,')!=-1"></el-table-column>
          <el-table-column prop="customer_source_name" label="客户来源" width="100" v-if="customerColumn.indexOf(',customer_source_name,')!=-1"></el-table-column>
          <el-table-column prop="lx_type" label="未联系天数" width="110" show-overflow-tooltip v-if="customerColumn.indexOf(',lx_type,')!=-1">
            <template v-slot="scope">
              <span>{{scope.row.lx_type.msg == '' ? '' : scope.row.lx_type.days + '天未联系'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="contact_times" label="联系次数" width="100" sortable='custom' v-if="customerColumn.indexOf(',contact_times,')!=-1"></el-table-column>
          <el-table-column prop="visit_times" label="回访次数" width="100" sortable='custom' v-if="customerColumn.indexOf(',visit_times,')!=-1"></el-table-column>
          <el-table-column prop="sell_amount" label="历史成交（次数）" width="160" show-overflow-tooltip sortable='custom' v-if="customerColumn.indexOf(',sell_count,')!=-1">
            <template v-slot="scope">
                <span>{{scope.row.sell_square_sum == null ? 0 : scope.row.sell_square_sum}} m³ ({{scope.row.sell_count}}次)</span>
            </template>
          </el-table-column>
          <el-table-column prop="visit_time" label="上次回访日期" width="120" show-overflow-tooltip v-if="customerColumn.indexOf(',visit_time,')!=-1" sortable='custom'></el-table-column>
          <el-table-column prop="visit_content" label="上次回访内容" width="120" show-overflow-tooltip v-if="customerColumn.indexOf(',visit_content,')!=-1"></el-table-column>
          <el-table-column prop="deal_time" label="上次交易时间" width="140" show-overflow-tooltip sortable='custom' v-if="customerColumn.indexOf(',deal_time,')!=-1"></el-table-column>  
          <el-table-column prop="main_business" label="主营项目" width="120" show-overflow-tooltip v-if="customerColumn.indexOf(',main_business,')!=-1"></el-table-column>
          <el-table-column prop="breed" label="采购品类" width="120" show-overflow-tooltip v-if="customerColumn.indexOf(',breed,')!=-1"></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="200" show-overflow-tooltip v-if="customerColumn.indexOf(',remark,')!=-1"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pag">
          <pagination v-if="refresh" ref="pagination" :lastpages.sync="pages.last_page" :currentpages.sync="pages.current_page" :all.sync="pages.total" :pagesizes.sync="pages.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 新增回访 -->
        <div v-if="showReturn">
          <addreturns :show="showReturn" type="newAdd" :id="customerID" :name="customerName" @closeReturn="handleCloseEmit" @addConfirmEvent="handleConfirmEvent"/>  
        </div> 
        <!-- 添加黑名单 -->
        <el-dialog v-dialog-drag title="添加黑名单" :visible.sync="addBlackListDialog" width="300px" top="15%" class="addBlackList" @close="blackListClose">
          <el-form :model="addBlackListForm" :inline="true">
          <el-form-item style="width: 100%; text-align: center;">
              <el-input type="textarea" :rows="3" placeholder="输入黑名单原因" style="width: 250px;" v-model="addBlackListForm.cause"></el-input>
          </el-form-item>  
          </el-form>
          <div slot="footer">
              <el-button class="benchBtn" @click="addBlackListDialog = false">取消</el-button>
              <el-button type="primary" class="benchBtn benchBtnChecked" style="margin-right: 32px;"  @click="blackListSave">保存</el-button>
          </div>
        </el-dialog> 
    </div>
</template>

<script>
import pagination from '../../../../components/pagination' 
import addreturns from '../../common/addReturn' 
import eventBus from '../../../../eventBus'
import tabletem from '../../../../components/table'

export default {
  
  components: {
    pagination,
    addreturns,
    tabletem
  },
  props:{
    type: String,
    customerData: {
      type: Array,
      default: function(){
        return [
          {

          }
        ]
      }
    }, 
    pages: {
      type: Object,
      default: function(){
        return {
          last_page: 0,
          total: 0,
          current_page: 1,
          per_page: 20
        }
      }
    },
    customerColumn: {
      type: String,
      default: function(){
        return ''
      }
    },
    isLoading:{
      type:Boolean
    }
  },
  data(){
    return {
        module:localStorage.dw_erp_power_code,
        showReturn: false,
        addBlackListDialog: false,
        addBlackListForm: {
            cause: ''
        },
        reallocateDialog: false,
        reallocateForm: {
            belong_id: ''
        },
        customerName: '',//公司名称
        customerID: 0, //公司ID
        
        refresh: true,
        currentRow: null,
        // tableCol: [  
        //     {colName:"客户名称",colKey:"name",isCanClick:true,},
        //     {colName:"联系人",colKey:"linkman",},//isArrayOnly:true, 
        //     {colName:"联系电话",colKey:"phone",},//isArrayOnly:true, 
        //     {colName:"归属人",colKey:"salesman_name",},
        //     {colName:"客户属性",colKey:"customer_attribute_name",},
        //     {colName:"未联系天数",colKey:"lx_type", },
        //     {colName:"客户来源",colKey:"customer_source_name",},
        //     {colName:"历史归属",colKey:"history_salesman_name",},
        //     {colName:"回访次数",colKey:"visit_times",},
        //     {colName:"联系次数",colKey:"contact_times",},
        //     {colName:"上次回访日期",colKey:"visit_time",},
        //     {colName:"上次交易时间",colKey:"deal_time",},
        //     {colName:"历史成交(次数)",colKey:"sell_count",htmlNodeFunc(row){
        //         return `<span>${row['sell_square_sum']}</span>(<span>${row['sell_count']}</span><span>次</span>)`;
        //     }
        //     },
        //     {colName:"主营业务",colKey:"main_business",},
        //     {colName:"采购品类",colKey:"breed",},
        //     {colName:"备注",colKey:"remark",},
        // ],
        tableLoading:false,
        selectRow:[],
        selectId:''
    } 
  },
  methods: {
    //排序
    sortThisColumn(column){
      if(column.prop == "contact_times" && column.order == "ascending"){
        this.$emit('sortAllCustomer',{order: "asc", column: "contact_times"})
      }else if(column.prop == "contact_times" && column.order == "descending"){
        this.$emit('sortAllCustomer',{order: "desc", column: "contact_times"})
      }else if(column.prop == "visit_times" && column.order == "ascending"){  
        this.$emit('sortAllCustomer',{order: "asc", column: "visit_times"})
      }else if(column.prop == "visit_times" && column.order == "descending"){
        this.$emit('sortAllCustomer',{order: "desc", column: "visit_times"})
      }else if(column.prop == "visit_time" && column.order == "ascending"){
        this.$emit('sortAllCustomer',{order: "asc", column: "visit_time"})
      }else if(column.prop == "visit_time" && column.order == "descending"){
        this.$emit('sortAllCustomer',{order: "desc", column: "visit_time"})
      }else if(column.prop == "deal_time" && column.order == "ascending"){        
        this.$emit('sortAllCustomer',{order: "asc", column: "deal_time"})
      }else if(column.prop == "deal_time" && column.order == "descending"){
        this.$emit('sortAllCustomer',{order: "desc", column: "deal_time"})
      }else if(column.prop == "sell_amount" && column.order == "ascending"){
        this.$emit('sortAllCustomer',{order: "asc", column: "sell_square_sum"})
      }else if(column.prop == "sell_amount" && column.order == "descending"){
        this.$emit('sortAllCustomer',{order: "desc", column: "sell_square_sum"})
      }else{
        this.$emit('sortAllCustomer',{order: "", column: ""})
        return
      }
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    //选中数据
    selectionChange(row){
      this.selectRow = row;
    },    
    handleRowClick(row){
      this.$emit("singleSelected", row.id)
      if(this.currentRow == row){
        this.currentRow = null
        row.checked = false
        this.setCurrent()
      }else{
        this.currentRow = row
        row.checked = true;
        this.customerID = this.selectRow[0].id;
        this.customerName = this.selectRow[0].name;
      }
    },
    //分页
    getPage(obj){
      this.$emit('pageChangeEvent', obj)
      this.currentRow = null
    }, 
    lintToInfo(id, name){
      localStorage.setItem("dw_erp_customer_id",id);
      localStorage.setItem("dw_erp_customer_name_workbench", name)
      this.$emit("parentHandle")
    },
    //
    addReturn(){
      if(this.selectRow.length<1){
        this.tip('选择回访客户', 'warning');
        return
      }
      this.customerID = this.selectRow[0].id;
      this.customerName = this.selectRow[0].name;
      this.showReturn = true;
    },
    handleCloseEmit(){
      this.showReturn = false
    },
    //黑名单弹窗
    addBlackList(){
      if(this.selectRow.length<1){
        this.tip('选择添加黑名单客户', 'warning');
        return
      }
      this.addBlackListDialog = true
    },
    //添加黑名单保存
    blackListSave(){
      this.selectId = this.selectRow[0].id;
      this.postFunc("erp/customer.index.hei", {customer_id: this.selectId, cause: this.addBlackListForm.cause}, ()=>{
        this.addBlackListDialog = false 
        //刷新客户统计数据 黑名单数据
        this.$emit('refreshCustomerData')
        this.currentRow = null
      })
    },
    //黑名单弹窗关闭事件
    blackListClose(){
      this.addBlackListForm.cause = ''
    },
    clearSetectRow(){
      this.currentRow = null
    },
    handleConfirmEvent(){
        this.$emit('refreshCustomerData')
        this.currentRow = null
    },
    addCommonList(){
      if(this.selectRow.length<1){
        this.tip('选择添加公共池客户', 'warning');
        return
      }
      this.$confirm('添加至公共客户池?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let arr = new Array();
        for(let i=0;i<this.selectRow.length;i++){
          arr.push(this.selectRow[i].id)
        }
        this.postFunc('erp/customer.add.common', {customer_id: arr,}, ()=>{
          //刷新客户统计数据 黑名单数据
          this.$emit("refreshCustomerData")
          this.$message({
              type: 'success',
              message: '添加成功!'
          })
          this.currentRow = null
        }, res=>{
          this.$message({
            type: 'warning',
            message: res.data.message
          })
        })     
      })
    }
  },
  created(){
    eventBus.$on("clearSelected", this.clearSetectRow)
  },
  destroyed(){
    eventBus.$off("clearSelected")
  },
  watch: {
    pages(){
      //强制刷新分页组件
      this.refresh= false
      this.$nextTick(()=>{
        this.refresh = true
      })
    }   
  }
}
</script>

<style scoped lang="scss">
.a_cus_wrap{
  display: flex;
  flex-direction: column;
  height: 100%;
  text-align: left;
  .table{
    flex: 1;
    margin-top: 5px;
    max-width: 100%!important;
    .link{
      color: #0099ff;
      cursor: pointer;
    }
    .link:hover{
      text-decoration: underline;
    }
    .hei{
        display: inline-block;
        width: 16px;
        height: 16px;
        line-height: 16px;
        border-radius: 50%;
        background: #333;
        color: #fff;
        font-size: 10px;
        text-align: center;
        margin-left: 3px;
    }
    .hideBox{
      width: 30px;
      height: 30px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      background: transparent;
    }
  }
  .pag{
    text-align: center;
    margin-bottom: 10px;
  }
}
.addBlackList /deep/ .el-dialog__header{
  font-weight: 600;
}
.addBlackList /deep/ .el-textarea__inner{
  border-color: #333;
  font-size: 12px;
}

.a_cus_wrap /deep/ .el-table__body tr.current-row>td{
  background-color: rgba(255, 235, 188, 0.75) !important;
}
.a_cus_wrap /deep/ .el-checkbox__inner:hover {
  border-color: #dcdfe6;
  cursor: default;
}

.a_cus_wrap /deep/ .el-table th.gutter {display: table-cell !important;}
.a_cus_wrap /deep/ .el-table th.gutter{display: block !important;width: 28px !important;}
.a_cus_wrap /deep/ .el-tablecolgroup.gutter{display: block !important;width: 28px !important;}
.a_cus_wrap /deep/ .el-table--border, .a_cus_wrap /deep/ .el-table--group {border: 1px solid #fff;}
.a_cus_wrap /deep/  .el-table--border th.gutter:last-of-type {border-bottom-color: #fff;border-top: 1px solid #ddd;position: relative;top: -1px;}
</style>